import { getParameterByName } from './lib/util';

/*
  this file: 
    -adds an error handling hook to the window to pass error to SDK
    -wraps Promise.catch with a function that will pass error to SDK
*/

const sendSdkErrorLog = (err) => {
  if (window.parent) {
    try {
      window.parent.postMessage(generateErrorLoad(err), '*');
    } catch {

    }
  };
};

window.onerror = (...err) => {
  sendAppError(err[0]);
  sendSdkErrorLog(err[4] || err[0]);
};

window.onunhandledrejection = (err) => {
  sendAppError();
  sendSdkErrorLog(err.reason);
};

const generateErrorLoad = (error) => {
  switch (error.code) {
    case 1:
      return {
        code: 1,
        title: "Unable to fetch PM",
        stackTrace: error.message
      };
    default:
      return {
        code: 99,
        title: 'general error',
        stackTrace: error
      };
  };
};

const sendAppError = (err = '') => {
  if (err.includes('Invalid signature')) {
    window.parent.postMessage({
      name: 'sp.renderingAppError',
      messageId: getParameterByName('message_id'),
      fromPM: false,
      invalidSignature: true
    }, '*');
  } else {
    window.parent.postMessage({ name: 'sp.renderingAppError', messageId: getParameterByName('message_id'), fromPM: window.__isPm }, '*');
  }
}